import { getBackVersion } from '../../config';
import { rawClient } from '../api';

const downloadSplitReceipt = (
    splitId: string,
    propertyId: number,
    destinationId: number,
    transferId?: string
): Promise<void> =>
    rawClient.download({
        method: 'GET',
        // eslint-disable-next-line camelcase
        params: { transfer_id: transferId },
        url: `${getBackVersion()}/landlord_area/properties/${propertyId}/splits/${splitId}/receipt/${destinationId}`,
    });

const downloadSplitEmptyReceipt = (
    splitId: string,
    propertyId: number
): Promise<void> =>
    rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/landlord_area/properties/${propertyId}/splits/${splitId}/receipt/empty`,
    });

export { downloadSplitEmptyReceipt, downloadSplitReceipt };
